// extracted by mini-css-extract-plugin
module.exports = {"quote":"HighlightedQuote_quote__32Jf0"};